// extracted by mini-css-extract-plugin
module.exports = {"xl":"style_xl__MSb2Y","l":"style_l__1jeXd","m":"style_m__3JvrB","s":"style_s__7gKLp","xs":"style_xs__1BOWf"};